import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import Box from "../../../../components/Box";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../../components/CustomMultiSelect";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTextInput from "../../../../components/CustomTextInput";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { ServiceService } from "../../../../services/ServiceService";

interface Props {
    generalInformationRef: any
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    name: string | undefined
    setName: React.Dispatch<React.SetStateAction<string | undefined>>
    description: string | undefined
    setDescription: React.Dispatch<React.SetStateAction<string | undefined>>
    isIncome: boolean
    setIsIncome: React.Dispatch<React.SetStateAction<boolean>>
    isOutcome: boolean
    setIsOutcome: React.Dispatch<React.SetStateAction<boolean>>
    selectedService: CustomSingleSelectModel | undefined
    setSelectedService: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCarryTypes: CustomMultiSelectModel[]
    setSelectedCarryTypes: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    isComplete: boolean
    setIsComplete: React.Dispatch<React.SetStateAction<boolean>>
    isScale: boolean
    setIsScale: React.Dispatch<React.SetStateAction<boolean>>
    selectedMultiplier: CustomSingleSelectModel | undefined
    setSelectedMultiplier: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedIntervalType: CustomSingleSelectModel | undefined
    setSelectedIntervalType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isCustomActive: boolean
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    selectedCurrencyType: CustomSingleSelectModel | undefined
    setSelectedCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isDynamicService: boolean
    setIsDynamicService: React.Dispatch<React.SetStateAction<boolean>>
    selectedCustomers: CustomMultiSelectModel[]
    setSelectedCustomers: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
}

const GeneralInformation = ({
    generalInformationRef,
    refNo,
    setRefNo,
    name,
    setName,
    description,
    setDescription,
    isIncome,
    setIsIncome,
    isOutcome,
    setIsOutcome,
    selectedService,
    setSelectedService,
    selectedCarryTypes,
    setSelectedCarryTypes,
    isComplete,
    setIsComplete,
    isScale,
    setIsScale,
    selectedMultiplier,
    setSelectedMultiplier,
    selectedIntervalType,
    setSelectedIntervalType,
    isCustomActive,
    setIsCustomActive,
    selectedCurrencyType,
    setSelectedCurrencyType,
    isDynamicService,
    setIsDynamicService,
    selectedCustomers,
    setSelectedCustomers,
}: Props) => {
    return (
        <div className='containerPart' ref={generalInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomTextInput isLabelRequired labelText="Kod" value={refNo} setValue={setRefNo} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput isLabelRequired labelText="Ad" value={name} setValue={setName} />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText="Açıklama" value={description} setValue={setDescription} />
                        </div>

                        <div className="col-md-4">
                            <Box flexDirection={"row"}>
                                <Box flex={1} justifyContent="center">
                                    <CustomSwitch
                                        labelText="Gelir"
                                        isLabelRequired
                                        isActive={isIncome}
                                        setIsActive={() => {
                                            setIsIncome(!isIncome);
                                            setIsOutcome(!isOutcome);
                                            setSelectedService(undefined);
                                        }}
                                    />
                                </Box>
                                <Box flex={1} justifyContent="center">
                                    <CustomSwitch
                                        labelText="Gider"
                                        isLabelRequired
                                        isActive={isOutcome}
                                        setIsActive={() => {
                                            setIsIncome(!isIncome);
                                            setIsOutcome(!isOutcome);
                                            setSelectedService(undefined);
                                        }}
                                    />
                                </Box>
                            </Box>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-8">
                            <CustomMultiSelect
                                labelText="Taşıma Yöntemi"
                                isLabelRequired
                                selectedValues={selectedCarryTypes}
                                onChange={setSelectedCarryTypes}
                                onMenuOpen={() => ConstantService.getConstantList('CARRY_TYPE')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-4">
                            <Box flexDirection={"row"}>
                                <Box flex={1} justifyContent="center">
                                    <CustomSwitch
                                        labelText="Komple"
                                        isLabelRequired
                                        isActive={isComplete}
                                        setIsActive={() => {
                                            setIsComplete(!isComplete);
                                            setIsScale(!isScale);
                                            setSelectedMultiplier(undefined);
                                            setSelectedIntervalType(undefined);
                                        }}
                                    />
                                </Box>
                                <Box flex={1} justifyContent="center">
                                    <CustomSwitch
                                        labelText="Baremli"
                                        isLabelRequired
                                        isActive={isScale}
                                        setIsActive={() => {
                                            setIsComplete(!isComplete);
                                            setIsScale(!isScale);
                                            setSelectedMultiplier(undefined);
                                            setSelectedIntervalType(undefined);
                                        }}
                                    />
                                </Box>
                            </Box>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Çarpan"
                                isLabelRequired
                                selectedValue={selectedMultiplier}
                                onChange={setSelectedMultiplier}
                                onMenuOpen={() => ConstantService.getConstantList('MULTIPLIER_TYPE')}
                                labelName='value'
                                valueName='constantId'
                                disabled={!isComplete}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Aralık Türü"
                                isLabelRequired
                                selectedValue={selectedIntervalType}
                                onChange={setSelectedIntervalType}
                                onMenuOpen={() => ConstantService.getConstantList('INTERVAL_TYPE')}
                                labelName='value'
                                valueName='constantId'
                                disabled={!isScale}
                            />
                        </div>

                        <div className="col-md-4">
                            <Box flexDirection={"row"}>
                                <Box flex={1} justifyContent="center">
                                    <CustomSwitch
                                        labelText="Dinamik Hizmet Kalemi"
                                        isLabelRequired
                                        isActive={isDynamicService}
                                        setIsActive={() => {
                                            setIsDynamicService(!isDynamicService);
                                            setSelectedService(undefined);
                                        }}
                                    />
                                </Box>
                                <Box flex={1} justifyContent="center">
                                    <CustomSwitch labelText="Aktif" isLabelRequired isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                </Box>
                            </Box>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Hizmet Kalemi"
                                isLabelRequired
                                selectedValue={selectedService}
                                onChange={setSelectedService}
                                onMenuOpen={() => ServiceService.getServiceList(isIncome)}
                                labelName='name'
                                valueName='serviceId'
                                additionalValue1Name={'incomePercentageName'}
                                disabled={isDynamicService}
                            />
                        </div>
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Döviz Cinsi"
                                isLabelRequired
                                selectedValue={selectedCurrencyType}
                                onChange={setSelectedCurrencyType}
                                onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>
                        <div className="col-md-4">
                            {/* Boş bırakılırsa şablon bütün müşterilerde çalışır. */}
                            <CustomMultiSelect
                                labelText="Müşteri"
                                selectedValues={selectedCustomers}
                                onChange={setSelectedCustomers}
                                onMenuOpen={() => CompanyService.getCompanyList({ isCustomer: true })}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;